import React from 'react';
import { HomeHeader } from './HomeHeader';
import { HeroSection } from './HeroSection';
import { ExpertPanel } from './ExpertPanel';
import { CoreSolutions } from './CoreSolutions';
import { ResearchHighlights } from './ResearchHighlights';
import { HomeTestimonials } from './HomeTestimonials';
import { MediaRecognition } from './MediaRecognition';
import { ScientificApproach } from './ScientificApproach';
import { FeaturedResources } from './FeaturedResources';
import { HomeNewsletter } from './HomeNewsletter';
import { TrustFooter } from './TrustFooter';
import { HealthAssessment } from './HealthAssessment';
export const HomePage = () => {
  return <div className="w-full min-h-screen bg-slate-50" data-id="element-2609">
      <div className="max-w-4xl mx-auto px-3 sm:px-6 py-4 sm:py-8 font-serif bg-white border border-slate-200 shadow-sm" data-id="element-2610">
        <HomeHeader data-id="element-2611" />
        <HeroSection data-id="element-2612" />
        <main className="prose prose-slate max-w-none" data-id="element-2613">
          <HealthAssessment data-id="element-2614" />
          <ExpertPanel data-id="element-2615" />
          <CoreSolutions data-id="element-2616" />
          <ResearchHighlights data-id="element-2617" />
          <HomeTestimonials data-id="element-2618" />
          <MediaRecognition data-id="element-2619" />
          <ScientificApproach data-id="element-2620" />
          <FeaturedResources data-id="element-2621" />
          <HomeNewsletter data-id="element-2622" />
          <TrustFooter data-id="element-2623" />
        </main>
      </div>
    </div>;
};